
import { useTranslation } from "react-i18next";

const messages = {
  hu: {
    title: "Az utolsó pecsét",
    first:
      "A huszonhatodik év tizedik holdja elsötétült. " +
      "Az utolsó jelet is bevésték, a Mesterek könyvét lezárták.",
    second:
      "Ha a lepecsételt kapu valaha újra megnyílik, " +
      "a negyedik hold alatt keresd.",
    third:
      "De már az őrző sem tudja, létezik-e még a kulcs.",
    ending: "Nem minden történet vár folytatásra."
  },
  en: {
    title: "The Last Seal",
    first:
      "The tenth moon of the twenty-sixth year has gone dark. " +
      "The final mark was carved; the Masters' book was closed.",
    second:
      "If the sealed gate ever opens again, " +
      "seek it beneath the fourth moon.",
    third:
      "Yet even the keeper no longer knows " +
      "if the key still exists.",
    ending: "Not every story awaits another chapter."
  },
  de: {
    title: "Das letzte Siegel",
    first:
      "Der zehnte Mond des sechsundzwanzigsten Jahres " +
      "ist erloschen. Das letzte Zeichen wurde eingeritzt; " +
      "das Buch der Meister wurde geschlossen.",
    second:
      "Sollte sich das versiegelte Tor je wieder öffnen, " +
      "suche es unter dem vierten Mond.",
    third:
      "Doch nicht einmal der Wächter weiß, " +
      "ob der Schlüssel noch existiert.",
    ending: "Nicht jede Geschichte wartet auf ein neues Kapitel."
  }
};

type Language = keyof typeof messages;

export default function Masters() {
  const { i18n } = useTranslation();

  const language = (
    i18n.resolvedLanguage || i18n.language || "hu"
  ).split("-")[0] as Language;

  const text = messages[language] || messages.hu;

  return (
    <div className="surface-body mc-wrap">
      <header
        className="mc-header"
        style={{
          maxWidth: 680,
          margin: "12vh auto",
          textAlign: "center"
        }}
      >
        <p
          className="mc-sub"
          style={{
            letterSpacing: "0.4em",
            opacity: 0.5
          }}
        >
          X · MMXXVI
        </p>

        <h1 className="mc-title">{text.title}</h1>

        <div
          style={{
            margin: "3rem auto",
            maxWidth: 540,
            lineHeight: 2
          }}
        >
          <p className="mc-intro">{text.first}</p>

          <p
            className="mc-intro"
            style={{ marginTop: "2rem" }}
          >
            {text.second}
          </p>

          <p
            className="mc-intro"
            style={{ marginTop: "2rem" }}
          >
            {text.third}
          </p>
        </div>

        <p
          style={{
            opacity: 0.45,
            fontStyle: "italic",
            fontSize: "0.85rem",
            marginTop: "4rem"
          }}
        >
          {text.ending}
        </p>
      </header>
    </div>
  );
}
